<template>
    <div class="profile_edit_content_block">
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-4 mt-3 p-4">
                    <text-input v-model="form.name" :error="form.errors.name" class="sm:col-span-2" label="Name"
                        required="true" placeholder="i.e." />
                    <text-input v-model="form.agent_no" :error="form.errors.agent_no" class="sm:col-span-2"
                        label="Agent ID" required="true" placeholder="i.e 1234" />
                    <text-input v-model="form.father_name" :error="form.errors.father_name" class="sm:col-span-2"
                        label="Father's Name" placeholder="i.e John Ivan" />
                    <text-input v-model="form.mother_name" :error="form.errors.mother_name" class="sm:col-span-2"
                        label="Mother's Name" placeholder="i.e Kate William" />
                    <text-date-picker v-model="form.dob" :error="form.errors.dob" class="sm:col-span-2"
                        label="Date of Birth" placeholder="i.e 01-01-2022" />

                    <text-input v-model="form.nid" :error="form.errors.nid" class="sm:col-span-2"
                        label="Government Issued ID" placeholder="i.e 1234567890123" required="true" />

                    <select-input v-model="form.gender_id" :error="form.errors.gender_id" class="sm:col-span-2"
                        label="Gender" required="true">
                        <option value=''>Select Gender</option>
                        <option v-for="gender in genders" :key="gender.id" :value='gender.id'>{{ gender.gender_name }}
                        </option>
                    </select-input>
                    <select-input v-model="form.religion_id" :error="form.errors.religion_id" class="sm:col-span-2"
                        label="Religion" required="true">
                        <option value=''>Select Religion</option>
                        <option v-for="religion in religions" :key="religion.id" :value='religion.id'>
                            {{ religion.name }}
                        </option>
                    </select-input>
                    <text-input-email v-model="form.email" :error="form.errors.email" :type="email"
                        class="sm:col-span-2" label="Email" required="true" placeholder="i.e example@test.com" />
                    <text-input v-model="form.password" :error="form.errors.password" class="sm:col-span-2"
                        label="Password" required="true" placeholder="i.e *****" />
                    <text-input v-model="form.mobile" :error="form.errors.mobile" :type="text" class="sm:col-span-2"
                        label="Mobile" required="true" placeholder="i.e +63-2-1234-5678" />
                    <select-input v-model="form.marital_status_id" :error="form.errors.marital_status_id"
                        class="sm:col-span-2" label="Marital Status">
                        <option value=''>Select Marital Status</option>
                        <option v-for="marital_status in marital_statuses" :key="marital_status.id"
                            :value='marital_status.id'>{{ marital_status.marital_statuse_name }}</option>
                    </select-input>
                    <text-date-picker v-model="form.date_of_joining" :error="form.errors.date_of_joining"
                        class="sm:col-span-2" label="Date of Joining" required="true" placeholder="i.e 01-01-2022" />
                    <select-input v-model="form.queue_office_id" :error="form.errors.queue_office_id"
                        class="sm:col-span-2" label="Office" required="true">
                        <option value=''>Select Office</option>
                        <option v-for="office in offices" :key="office.id" :value='office.id'>{{ office.office_name }}
                        </option>
                    </select-input>
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status"
                        class="sm:col-span-2 "></status-toogle-button>
                </div>
                <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
            </form>
        </div>
    </div>
</template>
<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject, onMounted, watch } from 'vue'
import axios from 'axios';
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import TextDatePicker from '@/Shared/TextDatePicker'
import TextInputEmail from '@/Shared/TextInputEmail'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Button from '@/Shared/Button'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        TextareaInput,
        TextDatePicker,
        TextInputEmail
    },
    props: {
        permission: Array,
        genders: Array,
        religions: Array,
        marital_statuses: Array,
        offices: Array
    },
    layout: Layout,
    remember: 'form',
    setup(props) {
        const { permission, marital_statuses, religions, genders, offices } = toRefs(props)
        const form = useForm({
            name: null,
            gender_id: null,
            date_of_joining: null,
            agent_no: null,
            father_name: null,
            mother_name: null,
            nid: null,
            dob: null,
            religion_id: null,
            email: null,
            mobile: null,
            marital_status_id: null,
            password: null,
            status: null,
            queue_office_id: null
        })
        const type = ref('create')
        const title = ref('Agent')
        const url = ref('/backend/queue-agents')
        const createUrl = ref('')
        const swal = inject('$swal')
        const store = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.post(`${url.value}`, { forceFormData: true, })
                    swal.fire(
                        'Added!',
                        'Your infomation has been Added.',
                        'success'
                    )
                }
            });
        }
        const set_photo = (val) => {
            form.icon_img = val
        }
        return {
            form,
            type,
            title,
            url,
            createUrl,
            store,
            permission,
            set_photo,
            marital_statuses,
            religions,
            genders,
            offices
        }
    }
}
</script>
<style lang="scss" scoped>
$button_height: 36;

.profile_edit_content_block {
    display: block;

    .edit_form_block {
        background-color: #ffffff80;

        input,
        textarea,
        select {
            width: 100%;
            border: 1px solid #ddd;
            padding: 5px 10px;
            border-radius: 5px;
        }

        i {
            display: none;
            width: 30px;
            text-align: center;
            transition: all 0.4s;
            color: #888;
            position: absolute;
            margin-left: 265px !important;
            margin-top: -23px;

            &.active {
                display: block;
            }
        }

        .err_msg {
            border-color: #CD0000 !important
        }
    }
}

.save_btn,
.cancel_btn {
    height: #{$button_height}px;
    background-color: #0f8050;
    color: #fff;
    cursor: pointer;
    border-radius: 5px;

    &.cancel_btn {
        border: 1px solid #CD0000;
        color: #CD0000;
        background-color: #fff;
    }
}

.dark {
    .profile_edit_content_block {

        input,
        textarea,
        select {
            background-color: #222;
        }
    }
}

.password_block,
.confirm_password_block {
    p {
        align-items: baseline;
        color: #666;
        display: flex;
        gap: 5px;
        font-size: 10px !important;

        span {
            color: gold !important;
            font-size: 10px !important;
        }
    }
}
</style>
